import { useInstallPrompt } from '@/hooks/useInstallPrompt';
import { useState } from 'react';
import { Icons } from '@/utils/Icons';

const InstallButton = () => {
  const { canInstall, isInstalled, isIOS, promptInstall } = useInstallPrompt();
  const [showIOSHint, setShowIOSHint] = useState(false);

  if (isInstalled || !canInstall) return null;

  const handleClick = () => {
    if (isIOS) {
      setShowIOSHint(true);
      return;
    }
    promptInstall();
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={handleClick}
        className="flex h-10 items-center gap-2 rounded-lg bg-gold px-4 text-sm font-semibold text-gold-foreground transition hover:bg-gold-hover"
      >
        <Icons.Android className="text-base" />
        Install App
      </button>
      {showIOSHint && (
        <div className="absolute bottom-full right-0 mb-2 w-52 rounded-lg border border-shell-border bg-shell-raised p-3 text-xs text-shell-fg shadow-lg">
          Tap the Share icon, then "Add to Home Screen"
          <button
            onClick={() => setShowIOSHint(false)}
            className="mt-2 block font-semibold text-gold hover:underline"
          >
            Got it
          </button>
        </div>
      )}
    </div>
  );
};

export default InstallButton;
